<section class="flex flex-col rounded-md w-full gap-3">
  @if (options()?.header?.show !== false) {
  <div class="flex gap-3 items-center w-full">
    <app-grid-header
      [(align)]="align"
      [(orderBy)]="orderBy"
      [columns]="columns()"
      [rowData]="rowData()"
      [(query)]="query"
      [(selecteds)]="selecteds"
      (export)="handleExport()"
      class="w-full">
      <ng-content name="[buttons]" />
    </app-grid-header>
  </div>
  } @if (options()?.view === 'table' || !options()?.view) {
  <app-grid-table [(align)]="align" [(orderBy)]="orderBy" [(selecteds)]="selecteds" />
  } @else {
  <app-grid-gallery [(align)]="align" [(orderBy)]="orderBy" />
  } @if (options()?.footer?.show !== false) {
  <section class="flex w-full justify-between items-center">
    <p class="font-semibold theme-text">
      전체
      <span class="text-primary-500 ml-1">{{ totalItems() | number }}</span>
    </p>
    @if (!options()?.searchOption?.disablePagination) {
    <div class="flex items-center gap-4">
      @if (pageInfo(); as pageInfo) {
      <app-pagination [(page)]="page" [pageInfo]="pageInfo" />
      }
      <select class="select focus-within:input-primary min-w-28" [(ngModel)]="pageSize">
        <option disabled selected>선택</option>
        <option value="5">5</option>
        <option value="10">10</option>
        <option value="15">15</option>
        <option value="20">20</option>
        <option value="50">50</option>
        <option value="100">100</option>
        <option value="500">500</option>
      </select>
    </div>
    }
  </section>
  }
</section>
